/* eslint-disable no-underscore-dangle */
// Lightweight structured logger for the conversation internal counsel.
// Disabled by default; toggle via `enableDebug()` or by setting
// `window.__COUNSEL_DEBUG = true` from the browser console. Mirrors the
// ai_assist / translation loggers so debugging stays consistent.
const SCOPE = 'counsel';
const SAFE_KEYS = new Set([
  'event',
  'conversationId',
  'threadId',
  'messageId',
  'role',
  'mode',
  'status',
  'count',
  'enabled',
  'busy',
  'kind',
]);

const isEnabled = () => {
  if (typeof window === 'undefined') return false;
  if (window.__COUNSEL_DEBUG === true) return true;
  const flag = window.localStorage?.getItem('counsel_debug');
  return flag === '1' || flag === 'true';
};

// Counsel content mixes agent notes and customer context; unknown string fields
// are reduced to their length so nothing quotable reaches the console.
const stripSensitive = payload => {
  if (!payload || typeof payload !== 'object') return payload;
  const cleaned = {};
  Object.keys(payload).forEach(key => {
    if (SAFE_KEYS.has(key)) {
      cleaned[key] = payload[key];
    } else if (typeof payload[key] === 'string') {
      cleaned[key] = `len:${payload[key].length}`;
    } else {
      cleaned[key] = payload[key];
    }
  });
  return cleaned;
};

export const logger = {
  enableDebug() {
    if (typeof window !== 'undefined') {
      window.__COUNSEL_DEBUG = true;
      window.localStorage?.setItem('counsel_debug', '1');
    }
  },
  disableDebug() {
    if (typeof window !== 'undefined') {
      window.__COUNSEL_DEBUG = false;
      window.localStorage?.removeItem('counsel_debug');
    }
  },
  isEnabled,
  info(event, payload = {}) {
    if (!isEnabled()) return;
    // eslint-disable-next-line no-console
    console.log(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
  warn(event, payload = {}) {
    if (!isEnabled()) return;
    // eslint-disable-next-line no-console
    console.warn(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
  error(event, payload = {}) {
    // eslint-disable-next-line no-console
    console.error(
      `[${SCOPE}] ${event}`,
      JSON.stringify({ ts: Date.now(), ...stripSensitive(payload) })
    );
  },
};

export default logger;
